import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarModule } from 'ngx-avatars';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ReportsHeaderComponent } from './reports-header/reports-header.component';
import { FilterDropdownComponent } from './reports-header/filter-dropdown/filter-dropdown.component';
import { TopUsageChartComponent } from './charts/top-usage-chart/top-usage-chart.component';
import { DailyUsageChartComponent } from './charts/daily-usage-chart/daily-usage-chart.component';
import { SecondsToHMPipe } from './seconds-to-hm.pipe';

@NgModule({
  declarations: [
    ReportsHeaderComponent,
    FilterDropdownComponent,
    TopUsageChartComponent,
    DailyUsageChartComponent,
    SecondsToHMPipe,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatCheckboxModule,
    AvatarModule,
    NgxSkeletonLoaderModule,
    MatPaginatorModule,
    MatTooltipModule,
  ],
  exports: [
    ReportsHeaderComponent,
    FilterDropdownComponent,
    TopUsageChartComponent,
    DailyUsageChartComponent,
    SecondsToHMPipe,
    // Re-export so ReportsModule declarations (stats / table / analysis) see the same UI primitives.
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatCheckboxModule,
    AvatarModule,
    NgxSkeletonLoaderModule,
    MatPaginatorModule,
    MatTooltipModule,
  ],
})
export class ReportsWidgetsModule {}
